var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.398 1.354l.127.12.12.128a2.982 2.982 0 01-.12 4.09l-9.973 9.974c-.231.23-.518.397-.833.483L1.456 17.31a.625.625 0 01-.767-.767L1.85 12.28c.086-.315.253-.602.483-.833l9.974-9.973a2.982 2.982 0 014.09-.12zM11.5 4.05l-8.282 8.282a.625.625 0 00-.16.278l-.876 3.208 3.208-.875a.625.625 0 00.278-.161L13.949 6.5 11.5 4.05zM4.438 8.166l-1.25 1.25H1.292a.625.625 0 110-1.25h3.146zM7.77 4.833l-1.25 1.25H1.29a.625.625 0 110-1.25h6.48zm5.421-2.474l-.809.807 2.45 2.45.808-.808a1.732 1.732 0 00-2.449-2.45zm-2.088-.86l-1.25 1.25-8.562.001a.625.625 0 110-1.25h9.812z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.dc59152a.svg";
export { ForwardRef as ReactComponent };